import "../App.css";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

function Navbar({ openModal }) {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="logo-container">
        {isHome ? (
          <ScrollLink to="hero" smooth={true} duration={500} style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: "pointer" }}>
            <img src="/logo.png" alt="Cabptoid" className="logo-img" />
            <div className="brand-wordmark">
              <span className="brand-main">Cabptoid</span>
              <span className="brand-sub">SOLUTIONS</span>
            </div>
          </ScrollLink>
        ) : (
          <RouterLink to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <img src="/logo.png" alt="Cabptoid" className="logo-img" />
            <div className="brand-wordmark">
              <span className="brand-main">Cabptoid</span>
              <span className="brand-sub">SOLUTIONS</span>
            </div>
          </RouterLink>
        )}
      </div>

      {/* Hamburger Icon */}
      <button className="hamburger-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
        {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
      </button>

      {/* Desktop Nav Links */}
      <ul className="nav-links desktop-nav">
        {isHome ? (
          <>
            <li><ScrollLink to="hero" spy={true} smooth={true} offset={-80} duration={500}>Home</ScrollLink></li>
            <li><ScrollLink to="services" spy={true} smooth={true} offset={-80} duration={500}>Services</ScrollLink></li>
            <li><ScrollLink to="about" spy={true} smooth={true} offset={-80} duration={500}>About</ScrollLink></li>
            <li><RouterLink to="/portfolio" style={{ cursor: 'pointer' }}>Portfolio</RouterLink></li>
            <li>
              <button className="nav-contact-btn" onClick={openModal}>
                Contact
              </button>
            </li>
          </>
        ) : (
          <>
            <li><RouterLink to="/">Home</RouterLink></li>
            <li><a href="/#about">About</a></li>
            <li><a href="/#services">Services</a></li>
            <li><RouterLink to="/portfolio">Portfolio</RouterLink></li>
            <li>
              <button className="nav-contact-btn" onClick={openModal}>
                Contact
              </button>
            </li>
          </>
        )}
      </ul>

      <motion.button
        className="btn-primary desktop-cta"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={openModal}
      >
        Get in Touch
      </motion.button>

      {/* Mobile Menu Drawer */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25 }}
          >
            <ul className="mobile-nav-links">
              {isHome ? (
                <>
                  <li><ScrollLink to="hero" smooth={true} offset={-80} duration={500} onClick={closeMenu}>Home</ScrollLink></li>
                  <li><ScrollLink to="services" smooth={true} offset={-80} duration={500} onClick={closeMenu}>Services</ScrollLink></li>
                  <li><ScrollLink to="about" smooth={true} offset={-80} duration={500} onClick={closeMenu}>About</ScrollLink></li>
                  <li><RouterLink to="/portfolio" onClick={closeMenu}>Portfolio</RouterLink></li>
                  <li><button className="nav-contact-btn" onClick={() => { closeMenu(); openModal(); }}>Contact</button></li>
                </>
              ) : (
                <>
                  <li><RouterLink to="/" onClick={closeMenu}>Home</RouterLink></li>
                  <li><a href="/#about" onClick={closeMenu}>About</a></li>
                  <li><a href="/#services" onClick={closeMenu}>Services</a></li>
                  <li><RouterLink to="/portfolio" onClick={closeMenu}>Portfolio</RouterLink></li>
                  <li><button className="nav-contact-btn" onClick={() => { closeMenu(); openModal(); }}>Contact</button></li>
                </>
              )}
            </ul>
            <motion.button
              className="btn-primary mobile-cta"
              whileTap={{ scale: 0.97 }}
              onClick={() => { closeMenu(); openModal(); }}
            >
              Get in Touch
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}

export default Navbar;